import { toSupportedDate } from './to-supported-date';
import { toSupportedPanel } from './to-supported-panel';
import type { NodeTransformer, ToSupportedNode } from './types';

const nodeTransformers: Record<string, NodeTransformer> = {
	date: toSupportedDate,
	panel: toSupportedPanel,
};

export const toSupportedNode: ToSupportedNode = (type, partialNodeJson) => {
	const nodeTransformer: NodeTransformer | undefined = nodeTransformers[type];

	return nodeTransformer ? nodeTransformer(partialNodeJson) : partialNodeJson;
};
